import {
  mapLabelBgColor,
  mapLabelColor,
} from '../../../fragments/OfferCardWidget/shared/components/LabelsList/mapColors';
import { ELabelColor } from '../../../fragments/OfferCardWidget/shared/types/label';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const getEtazhiBlackFridayPriceDiscountColors = (color: ELabelColor) => {
  return {
    bgColor: mapLabelBgColor(color),
    color: mapLabelColor(color),
    strikethroughColor: mapLabelBgColor(color),
  };
};
